/* global axios */
import ApiClient from '../ApiClient';

class OnixActionsAPI extends ApiClient {
  constructor() {
    super('onix/actions', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: { page, searchKey },
    });
  }

  test(id, params = {}) {
    return axios.post(`${this.url}/${id}/test`, { params });
  }
}

export default new OnixActionsAPI();
